import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import DetallesModal from "../../components/Common/DetallesModal"

import {
  Container,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Button,
} from "reactstrap"
import Paginations from "components/Common/Pagination"
import Spinners from "components/Common/Spinner"
import { Link } from "react-router-dom"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"

import { getCredencialesListaCredenciales as onGetCredencialesList } from "store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useCampusVirtualIdCampus } from "../../store/campusvirtual/selectors"

import {
  useCredencialesCredenciales,
  useCredencialesError,
  useCredencialesIsLoading,
} from "store/selectors"

//i18n
import { withTranslation } from "react-i18next"

const Credenciales = props => {
  //meta title
  document.title = "Credenciales | CampusVirtual"

  const credenciales = useCredencialesCredenciales()
  const error = useCredencialesError()
  const isLoading = useCredencialesIsLoading()
  const idCampus = useCampusVirtualIdCampus()

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [job, setJob] = useState(null)

  const [sListaIdStatus, setsListaIdStatus] = useState("1,4")

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      jobId: (job && job.jobId) || "",
      jobTitle: (job && job.jobTitle) || "",
      companyName: (job && job.companyName) || "",
      location: (job && job.location) || "",
      experience: (job && job.experience) || "",
      position: (job && job.position) || "",
      type: (job && job.type) || "",
      status: (job && job.status) || "",
    },
    validationSchema: Yup.object({
      jobId: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, "Please Enter Valid Job Id")
        .required("Please Enter Your Job Id"),
      jobTitle: Yup.string().required("Please Enter Your Job Title"),
      companyName: Yup.string().required("Please Enter Your Company Name"),
      location: Yup.string().required("Please Enter Your Location"),
      experience: Yup.string().required("Please Enter Your Experience"),
      position: Yup.string().required("Please Enter Your Position"),
      type: Yup.string().required("Please Enter Your Type"),
      status: Yup.string().required("Please Enter Your Status"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateJobList = {
          id: job ? job.id : 0,
          jobId: values.jobId,
          jobTitle: values.jobTitle,
          companyName: values.companyName,
          location: values.location,
          experience: values.experience,
          position: values.position,
          type: values.type,
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values.status,
        }
        // update Job
        //dispatch(onUpdateJobList(updateJobList))
        validation.resetForm()
      } else {
        const newJobList = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          jobId: values["jobId"],
          jobTitle: values["jobTitle"],
          companyName: values["companyName"],
          location: values["location"],
          experience: values["experience"],
          position: values["position"],
          type: values["type"],
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values["status"],
        }
        // save new Job
        //dispatch(onAddNewJobList(newJobList))
        validation.resetForm()
      }
      toggle()
    },
  })

  const dispatch = useDispatch()

  useEffect(() => {
    //if (credenciales && !credenciales.length) {
    idCampus > 0
      ? dispatch(
          onGetCredencialesList({
            nombreSolicitud: "getcredenciales",
            idCampus: idCampus,
            fechaInicio: new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1
            ),
            fechaFinal: new Date(),
          })
        )
      : null
    //}
  }, [dispatch, idCampus])

  useEffect(() => {
    if (error.length) {
      // dispatch(
      //   onGetAlumnosList({
      //     nombreSolicitud: "listacredencialesxidcampusxlistastatus",
      //     idCampus: 5,
      //     sListaIdStatus: "1,4",
      //   })
      // )
      toast.error(error, {
        autoClose: 3000,
      })
    }
  }, [dispatch, error])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setJob(null)
    } else {
      setModal(true)
    }
  }

  const handleJobClick = arg => {
    const job = arg
    setIsEdit(true)

    toggle()
  }

  const handleStatusFilterSelection = args => {
    console.log(args)
    setsListaIdStatus(args)
  }

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = job => {
    setDeleteModal(true)
  }

  const statusOptions = [
    { text: "Activos & Suspendidos", value: "1,4" },
    { text: "Activos", value: "1" },
    { text: "Baja", value: "2" },
    { text: "Titulado", value: "3" },
    { text: "Suspendido", value: "4" },
    { text: "Pasante", value: "5" },
    { text: "Egresado", value: "6" },
    { text: "Prospecto", value: "7" },
    { text: "Seguimiento", value: "8" },
    { text: "ST Baja", value: "9" },
    { text: "Todos", value: "1,2,3,4,5,6,7,8,9" },
  ]

  const handleDeletejob = () => {}

  const columns = useMemo(
    () => [
      {
        header: "id",
        accessorKey: "id_Credencial",
        enableColumnFilter: false,
        enableSorting: true,
        size: 20,
        cell: cellProps => {
          return (
            <Link to="#" className="text-body fw-bold">
              {cellProps.row.original.id_Credencial}
            </Link>
          )
        },
      },
      {
        header: "Nombre",
        accessorKey: "apellidopaterno_apellido_materno_nombre",
        enableColumnFilter: false,
        enableSorting: true,
        size: 100,
      },
      {
        header: "Impresa",
        accessorKey: "Impresa",
        enableColumnFilter: false,
        enableSorting: true,
        size: 20,
      },
      {
        header: "No_Impresiones",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "No_Impresiones",
        size: 50,
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        size: 50,
        cell: cellProps => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to="#"
                  onClick={() => setModal(true)}
                  className="btn btn-sm btn-soft-primary"
                  id={`viewtooltip-${cellProps.row.original.id_Credencial}`}
                >
                  <i className="mdi mdi-eye-outline" />
                </Link>
              </li>
              <UncontrolledTooltip
                placement="top"
                target={`viewtooltip-${cellProps.row.original.id_Credencial}`}
              >
                Detalles
              </UncontrolledTooltip>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={() => {
                    const jobData = cellProps.row.original
                    handleJobClick(jobData)
                  }}
                  id={`edittooltip-${cellProps.row.original.id_Credencial}`}
                >
                  <i className="mdi mdi-pencil-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`edittooltip-${cellProps.row.original.id_Credencial}`}
                  >
                    Editar
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={() => {
                    const jobData = cellProps.row.original
                    onClickDelete(jobData)
                  }}
                  id={`deletetooltip-${cellProps.row.original.id_Credencial}`}
                >
                  <i className="mdi mdi-delete-outline" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deletetooltip-${cellProps.row.original.id_Credencial}`}
                  >
                    Baja
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Credenciales")}
            breadcrumbItem={props.t("Credenciales")}
          />
          <Row>
            <Col lg="12">
              <Card>
                <ToastContainer />
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title flex-grow-1">
                      Credenciales
                    </h5>
                    <div className="flex-shrink-0">
                      <Link
                        to="#!"
                        onClick={() => setModal(true)}
                        className="btn btn-primary me-1"
                      >
                        Agregar Credencial
                      </Link>
                      <Link
                        to="#!"
                        onClick={() => {
                          console.log("Click")
                          toast.success("Consulta exitosa", {
                            autoClose: 2000,
                          })
                        }}
                        className="btn btn-light me-1"
                      >
                        <i className="mdi mdi-refresh"></i>
                      </Link>
                      <UncontrolledDropdown className="dropdown d-inline-block me-1">
                        <DropdownToggle
                          type="menu"
                          className="btn btn-success"
                          id="dropdownMenuButton1"
                        >
                          <i className="mdi mdi-dots-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <li>
                            <DropdownItem href="#">Action</DropdownItem>
                          </li>
                          <li>
                            <DropdownItem href="#">Another action</DropdownItem>
                          </li>
                          <li>
                            <DropdownItem href="#">
                              Something else here
                            </DropdownItem>
                          </li>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {isLoading ? (
                    <Spinners setLoading={() => {}} />
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={credenciales || []}
                      isCustomPageSize={false}
                      isGlobalFilter={true}
                      // divClassName="container"
                      //isAddButton={true}
                      buttonClass="btn btn-primary btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
                      buttonName=" Add New Order"
                      handleUserClick={handleStatusFilterSelection}
                      isJobListGlobalFilter={true}
                      statusOptions={statusOptions}
                      isPagination={true}
                      SearchPlaceholder="Búsqueda ..."
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      selectedValue={sListaIdStatus}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal size="xl" isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h5">
              {!!isEdit ? "Editar Credencial" : "Agregar Credencial"}
            </ModalHeader>
            <ModalBody>
              <DetallesModal />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

Credenciales.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Credenciales)
